import React from 'react'
import { EditableComponent } from '@adobe/aem-react-editable-components'
import { StepIndicator as UIFoundationsStepIndicator } from '@dcxwam/dcx-wam-ui-foundations'
import StepIndicatorEditConfig, {
  hasRequiredStepIndicatorProps
} from './StepIndicatorEditConfig'
import { StepIndicatorModelProps } from './types'
import { EditableComponentPropsType } from '../../../utils/prop-types'
import withComponentRefresh from '../../../utils/aem/editor/withComponentRefresh'
import { useExtractEditableProps } from '../../../utils/aem/editor/extractEditableProps'
import {
  WithAutomaticTestIdsType,
  withAutomaticTestIds
} from '../../../utils/aem/with-automatic-test-ids'
import {
  withErrorBoundary,
  ErrorFallback
} from '../../functional/ErrorBoundary'

const StepIndicator = withComponentRefresh(
  withAutomaticTestIds(
    (
      props: WithAutomaticTestIdsType<
        EditableComponentPropsType<StepIndicatorModelProps>
      >
    ) => {
      const { currentStep, totalSteps, label, ariaLabel, id, ...rest } =
        props.model
      const { getDataTestIdObject } = props
      const editableProps = useExtractEditableProps(props, rest)

      // Grouped so the edit config's type guard can narrow all four required
      // props at once, without casts or non-null assertions. The guard also
      // rejects step counts the UI Foundations component would divide by
      // unsafely (0, negatives, NaN, Infinity, fractions, current > total).
      const requiredModel = { currentStep, totalSteps, label, ariaLabel }

      return (
        <EditableComponent {...editableProps}>
          {hasRequiredStepIndicatorProps(requiredModel) ? (
            <UIFoundationsStepIndicator
              {...requiredModel}
              id={id}
              {...getDataTestIdObject('step-indicator', id)}
            />
          ) : (
            StepIndicatorEditConfig.emptyLabel
          )}
        </EditableComponent>
      )
    }
  )
)

const StepIndicatorWithErrorBoundary = withErrorBoundary(StepIndicator, {
  componentName: 'StepIndicator',
  fallback: <ErrorFallback componentName="StepIndicator" />
})

export default StepIndicatorWithErrorBoundary
